import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { CurrentDeals } from './components/CurrentDeals';
import { CompletedDeals } from './components/CompletedDeals';
import { DealReport } from './components/DealReport';
import { HowItWorks } from './components/HowItWorks';
import { DealAlerts } from './components/DealAlerts';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0" data-mp="2mndna7xolord">
      <Navbar data-id="element-1" data-mp="31b8ka0iq2fa9" />
      <Hero data-id="element-2" data-mp="31ayvgg9eye65" />
      <Philosophy data-id="element-3" data-mp="31bi9hlvy0iew" />
      <CurrentDeals data-id="element-4" data-mp="31c1jmgfcq2id" />
      <CompletedDeals data-id="element-5" data-mp="31cjjro54x0vk" />
      <DealReport data-id="element-6" data-mp="2wjgrrkg09zhh" />
      <HowItWorks data-id="element-7" data-mp="2wiywaq163pam" />
      <DealAlerts data-id="element-8" data-mp="2wifgpfyzpczr" />
      <About data-id="element-9" data-mp="2whxabqim5ie4" />
      <Footer data-id="element-10" data-mp="28ufqch5lbolp" />
    </div>;
}